export default "__VITE_ASSET__BZt6mBsd__"